import styled from 'styled-components';

export const JobSection = styled.div`
  display: flex;
  min-width: 0;
  gap: 12px;
  @media (max-width: 767px) {
    flex-direction: column;
  }
  align-items: start;
  padding: 20px 0;
`;
